import React, { useRef } from "react";
import Layout from "./Layout";
import { Link } from "react-router-dom";
import getStarted from "./imgs/get_started_btn.webp";
import CookieConsent from "react-cookie-consent";
import sf_demo from "./imgs/sf_demo.mp4";
import zombie from "./imgs/zombie.webm";
import avatar from "./imgs/avatar_demo.webm";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import book from "./imgs/book.png";
import coin from "./imgs/dashicons_money-alt.png";
import snapcamera from "./imgs/ic_baseline-snapchat.png";
import carbon from "./imgs/carbon_area-custom.png";
import lucide from "./imgs/lucide_network.png";
import obs from "./imgs/simple-icons_obsstudio.png";
import tl from "./imgs/top_left_faq.webp";
import tr from "./imgs/top_right_faq.webp";
import bl from "./imgs/bottom_left_faq.webp";
import br from "./imgs/bottom_right_faq.webp";
import bm from "./imgs/bottom_middle_faq.webp";
import hero_bg from "./imgs/bg_round_shapes_new.svg";
import hero_girl from "./imgs/hero-girl.webp";
import hero_boy from "./imgs/hero-boy.webp";
import checkmark from "./imgs/checkmark.png";
import coinImg from "./imgs/coins.webp";
import thunderImg from "./imgs/thunder.webp";
import maskImg from "./imgs/mask.webp";

function LandingPage() {
  const featuresRef = useRef(null);

  return (
    <Layout>
      {/* <div className="linked_pages_twitch">
        <Link
          to={"http://twitchcon-snapshot.s3-website-us-west-1.amazonaws.com"}
          target="_blank"
          rel="noopener noreferrer"
          className="twitch-btn"
        >
          <img src={twitch} alt="Logo" className="twitch-mob" />{" "}
          <p className="twitch-photo">PhotoBooth</p>
        </Link>
      </div>
      <div className="paragraph">
        <img
          src={mobileTitle}
          alt="mobile_title"
          className="mt-3 shadow-sm room-img"
        />
        <div className="linked_pages">
          <Link to={"/streamers"} className="image-link">
            <img src={getStarted} className="btn-img" alt="getstarted" />
          </Link>
        </div>
        <div className="subheader">
          <h4 className="header-subtitle">UPGRADE YOUR STREAM WITH AR</h4>
          <img src={alert} className="alert" alt="alert" />
        </div>
      </div> */}
      <section className="new-hero-section">
        <img src={hero_bg} alt="hero-bg" className="background_image" />
        <img src={hero_girl} alt="hero-bg" className="hero_girl" />
        <img src={hero_boy} alt="hero-bg" className="hero_boy" />
        <div className="new-hero-wrapper">
          <h1 className="hero_title">
            Upgrade Your Stream With <span>AR</span>
          </h1>
          <ul className="benefits">
            <li>
              Free <img src={checkmark} alt="" />
            </li>
            <li>
              No Download <img src={checkmark} alt="" />
            </li>
            <li>
              Integrate in OBS within 2 minutes <img src={checkmark} alt="" />
            </li>
            <li>
              Triggered by Twitch Events and Streamdeck{" "}
              <img src={checkmark} alt="" />
            </li>
          </ul>
          <Link to={"https://app.streamfog.com"} target="_blank">
            <img src={getStarted} alt="getstarted" />
          </Link>
        </div>
        <div
          class="scroll-down"
          onClick={() =>
            featuresRef.current.scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center",
            })
          }
        >
          <div class="animate">Scroll Down</div>{" "}
        </div>
      </section>

      {/* <!--Just for Desktop Separate Section--> */}
      <section className="section_features_main" ref={featuresRef}>
        <div className="container-fluid">
          <img src={coinImg} className="coin-img" alt="" />
          <img src={thunderImg} className="thunder-img" alt="" />
          <img src={maskImg} className="mask-img" alt="" />
          <h6
            className="section-title"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            Features
          </h6>

          <Grid container spacing={6}>
            <Grid item md={4}>
              <p className="feature-title">
                <span>AR</span> Animation
              </p>
              <div className="feature_video-wrapper">
                <video
                  autoplay="autoplay"
                  loop
                  muted
                  controls={window.innerWidth < 767 ? "controls" : false}
                  // playsInline={true}
                  playsinline
                  preload="auto"
                  className="feature-video green-shadow"
                  width="100%"
                  webkit-playsinline="true"
                  x-webkit-airplay="true"
                >
                  <source src={sf_demo} type="video/webm" />
                </video>
              </div>
              <span className="feature-decs">
                Streamfog provides a quantity of unique alerts. From generic to
                specific animations. You can even import your own !
              </span>
            </Grid>
            <Grid item md={4}>
              <p className="feature-title">
                Face <span>Filters</span>
              </p>
              <div className="feature_video-wrapper">
                <video
                  autoplay="autoplay"
                  loop
                  muted
                  controls={window.innerWidth < 767 ? "controls" : false}
                  playsinline
                  preload="auto"
                  className="feature-video green-shadow"
                  width="100%"
                  webkit-playsinline="true"
                  x-webkit-airplay="true"
                >
                  <source src={avatar} type="video/webm" />
                </video>
              </div>
              <span className="feature-decs">
                Enhance your face with a exclusive face filters.
              </span>
            </Grid>
            <Grid item md={4}>
              <p className="feature-title">
                Custom Faces with <span>AI</span>
              </p>
              <div className="feature_video-wrapper">
                <video
                  autoplay="autoplay"
                  loop
                  muted
                  controls={window.innerWidth < 767 ? "controls" : false}
                  playsinline
                  preload="auto"
                  className="feature-video green-shadow"
                  width="100%"
                  webkit-playsinline="true"
                  x-webkit-airplay="true"
                >
                  <source src={zombie} type="video/webm" />
                </video>
              </div>
              <span className="feature-decs">
                Be creative and make your own custom faces
              </span>
            </Grid>
          </Grid>
        </div>
      </section>
      {/* <!-- FAQ Section --> */}
      <section className="section-picture">
        <div className="desktop-faqs">
          <div className="container-fluid">
            <img src={tr} alt="faq" className="faq_img_tr" />
            <img src={tl} alt="faq" className="faq_img_tl" />
            <div className="section-title-div">
              <h6 className="section-title mb-3">Frequently asked Questions</h6>
              <Typography className="section-subtitle" sx={{ fontWeight: 700 }}>
                Quick answers to questions you may have. Feel free to join our
                <Link to="https://discord.gg/Z68pjTHfuK" target="_blank">
                  {" "}
                  Discord{" "}
                </Link>{" "}
                server for further assistance
              </Typography>
            </div>
            <Grid container spacing={2}>
              <Grid item lg={4} md={6}>
                <Box className="faq_box">
                  <div className="faq_box_h">
                    <img src={book} alt="book" />
                    <Typography variant="h5" component="div" color="white">
                      How Can I get started?
                    </Typography>
                  </div>
                  <Typography variant="body2" color="white">
                    The easiest way is to watch our YouTube{" "}
                    <Link to={"/streamers"}>tutorial</Link>.
                  </Typography>
                </Box>
              </Grid>
              <Grid item lg={4} md={6}>
                <Box className="faq_box">
                  <div className="faq_box_h">
                    <img src={coin} alt="coin" />
                    <Typography variant="h5" component="div" color="white">
                      Is Streamfog free?
                    </Typography>
                  </div>
                  <Typography variant="body2" color="white">
                    Yes, streamfog is free to use. Forever. We are currently
                    only charging for custom assets.
                  </Typography>
                </Box>
              </Grid>
              <Grid item lg={4} md={6}>
                <Box className="faq_box">
                  <div className="faq_box_h">
                    <img src={snapcamera} alt="book" />
                    <Typography variant="h5" component="div" color="white">
                      What is the difference to SnapCamera?
                    </Typography>
                  </div>
                  <Typography variant="body2" color="white">
                    SnapCamera was a byproduct of SnapChat that showed the
                    potential and also the popularity for AR in Streaming.
                    Unfortunately, it was never mantained or tailored to be a
                    tool for streamers. We created streamfog for streamers.
                    Similar techonology, but better integration with OBS and
                    Twitch.
                  </Typography>
                </Box>
              </Grid>
              <Grid item lg={4} md={6} style={{ position: "relative" }}>
                <Box className="faq_box">
                  <div className="faq_box_h">
                    <img src={carbon} alt="book" />{" "}
                    <Typography variant="h5" component="div" color="white">
                      Can I use custom assets?
                    </Typography>
                  </div>
                  <Typography variant="body2" color="white">
                    Yes, and you should if you want the animations to interact
                    with your room. As a 3D-Artist, you can create your own
                    assets and import them. You can also find artists on
                    platforms like fiver. We describe how assets can be created{" "}
                    <Link to={"/artists"}>here</Link>.<br></br>
                    <br></br>
                    We are also offering the creation of custom assets. You can
                    get a quote <Link to={"/artists"}>here</Link>.
                  </Typography>
                </Box>
                <img src={bl} alt="faq" className="faq_img_bl" />
              </Grid>
              <Grid item lg={4} md={6} style={{ position: "relative" }}>
                <Box className="faq_box">
                  <div className="faq_box_h">
                    <img src={obs} alt="book" />
                    <Typography variant="h5" component="div" color="white">
                      Why do I need to change my OBS Shortcut?
                    </Typography>
                  </div>
                  <Typography variant="body2" color="white">
                    The browser source needs camera access, but OBS cannot ask
                    you for permission. The flag fixes that.
                  </Typography>
                  <img src={bm} alt="faq" className="faq_img_bm" />
                </Box>
              </Grid>
              <Grid item lg={4} md={6} style={{ position: "relative" }}>
                <Box className="faq_box">
                  <div className="faq_box_h">
                    <img src={lucide} alt="book" />
                    <Typography variant="h5" component="div" color="white">
                      Am I sending my camera to some server?
                    </Typography>
                  </div>
                  <Typography variant="body2" color="white">
                    No! Your camera stream never leaves your PC. In fact, if you
                    disconnect from the Internet, you can observe that the
                    camera is still visible. Everything happens locally, no one
                    can see your camera - unless you start streaming.
                  </Typography>
                  <img src={br} alt="faq" className="faq_img_br" />
                </Box>
              </Grid>
            </Grid>
          </div>
        </div>
      </section>
      <CookieConsent
        enableDeclineButton
        flipButtons
        style={{
          background: "#171d21",
          display: "block",
          textAlign: "center",
          maxWidth: 300,
          padding: "10px 10px 30px",
          boxShadow: "0px 0px 20px rgba(0,0,0,0.2)",
          left: 20,
          marginBottom: 20,
          border: "1px solid #7cd959",
        }}
        buttonStyle={{
          background: "#7cd959",
          fontWeight: 700,
          margin: 0,
        }}
        declineButtonStyle={{ fontWeight: 700, margin: 0, marginLeft: 20 }}
      >
        <h5
          style={{ opacity: 0.9, textTransform: "uppercase", color: "#7cd959" }}
        >
          We use cookies
        </h5>
        <p style={{ opacity: 0.9, marginBottom: 0 }}>
          Cookies help us deliver the best experience on our website. By using
          our website, you agree to the use of cookies.
        </p>
      </CookieConsent>
    </Layout>
  );
}

export default LandingPage;
